import type { Mutation } from 'vuex'
import type { Params, State } from './state'

import actionTypes from './actionTypes'

import type { CodesDetail } from '@/api/model/basicTypes'
import { deepCopy } from '@/utils'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_SEND_MAIL_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },

  [actionTypes.SET_PARAMS]: (state: State, item: Params) => {
    state.params = { ...item }
  },

  [actionTypes.SET_TOTAL_COUNT]: (state: State, count: number) => {
    state.total_count = count
  },

  [actionTypes.SET_RECEIVE_COUNT]: (state: State, count: number) => {
    if (count == 0) {
      state.receive_count = -1
      setTimeout(() => {
        state.receive_count = count
      }, 200)
    } else {
      state.receive_count = count
    }
  },

  [actionTypes.SET_SEND_COUNT]: (state: State, count: number) => {
    if (count == 0) {
      state.send_count = -1
      setTimeout(() => {
        state.send_count = count
      }, 200)
    } else {
      state.send_count = count
    }
  },

  [actionTypes.SET_FOLDER_CHANGE_MODAL_STATUS]: (state: State, count: boolean) => {
    state.folderChangeModalStatus = count
  },

  [actionTypes.SET_TRANSACTION_STATUS_INFO](state, info: CodesDetail): void {
    state.transactionStatusInfo = deepCopy(info)
  },

  [actionTypes.SET_TRANSACTION_STATUS](state, value: string): void {
    state.transactionStatus = value
  },
  [actionTypes.SET_REMIND_SEND_MAIL_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },

  [actionTypes.SET_REMIND_PARAMS]: (state: State, item: Params) => {
    state.params = { ...item }
  },

  [actionTypes.SET_REMIND_TOTAL_COUNT]: (state: State, count: number) => {
    state.total_count = count
  },

  [actionTypes.SET_REMIND_SEND_MAIL_CHOOSED_DETAIL]: (state: State, data: Array<any>) => {
    state.choosed_detail = data
  },}

export default mutations
